
import Vue from "vue";
import SubHeader from "@/views/layout/header/SubHeader.vue";
import Search from "@/components/Search.vue";
import { Component } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import api from "@/api";
import TicketModel from "@/models/createTicket/TicketModel";
import TextFloating from "@/components/input/TextFloating.vue";
import FileInput from "@/components/input/FileInput.vue";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import utils from "@/utils";
import AttachmentModel from "@/models/createTicket/AttachmentModel";
import { UserModule } from "@/store/modules/user";
import WorkorderModel from "@/models/createTicket/WorkorderModel";
@Component({
    components: {
        SubHeader,
        Search,
        MenuFooter,
        FileInput,

        ValidationObserver,
        ValidationProvider,
        TextFloating,
    },
})
export default class ListNotification extends Vue {
    mounted() {
        this.getDetailFeedback(this.$route.params.id);
        
    }
    utils = utils;
    titlePage = "Assessment Report";
    userDetail = UserModule.userDetail;

    ticket: any | null = null;
    workorder: WorkorderModel | null = null;
    note = null;
    addFeedback() {
        this.$router.push("/ticket-feedback-approval/" + this.$route.params.id);
    }
    editFeedback() {
        this.$router.push("/ticket-feedback-edit/" + this.ticket.work_orders_id +"/" + this.$route.params.id);
    }
    getDetailFeedback(idTicket: string) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getFeedback(idTicket)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.ticket = Object.assign({}, response.data.data);
                        const verificator = this.ticket?.verificator;
                        if (verificator) {
                            const ver = JSON.parse(verificator ?? '{}');
                            const vers = Object.values(ver).filter((e:any) => e.status === 'Rejected');
                            const verss : any = vers[vers.length - 1];
                            if(verss){
                                if (verss.hasOwnProperty("note")) {
                                    this.note = verss["note"];
                                }
                            }
                        }
                        this.getDetailWorkorder(this.ticket?.work_orders_id);
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    getDetailWorkorder(idTicket: string) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getDetailTask2(idTicket)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.workorder = Object.assign(
                            {},
                            response.data.data
                        );
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    get colorStatus() {
        if (this.ticket?.workorder?.status === "new") {
            return "cl-red";
        } else {
            return "cl-green-light";
        }
    }
    get pitaStatus() {
        if (this.ticket?.workorder?.status === "new") {
            return "new";
        } else {
            return "on-progress";
        }
    }
}
